









import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import planCover from './planCover.vue'

@Component({
  name: "loadImage",
  components: {
    planCover
  }
})
export default class extends Vue {
  @Prop({ default: "" }) private imgList!: string;
  maxRequestNum = 4;
  imgListArr: string[] = []

  @Watch('imgList', {immediate: true})
  watchImgList(v: string){
    if(v){
      this.imgListArr = v.split(',')
    }
  }
  async created() {}
}
